import React from 'react';
import { CtaButton } from './CtaButton';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 px-4 bg-brand-purpleLight overflow-hidden" data-id="element-86">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-87">
        {/* Text Content */}
        <div className="flex flex-col gap-6 text-center md:text-left z-10" data-id="element-88">
          <div className="inline-flex bg-brand-yellowLight text-brand-purpleDark px-4 py-1.5 rounded-full w-fit mx-auto md:mx-0 font-semibold text-sm border border-brand-yellow/30" data-id="element-89">
            Para dueñas de air fryer que no la usan
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-darkGray leading-tight" data-id="element-90">
            Tu air fryer lleva meses guardada.{' '}
            <span className="italic text-brand-purple" data-id="element-91">Hoy eso cambia.</span>
          </h1>

          <p className="text-lg text-brand-mediumGray font-medium leading-relaxed" data-id="element-92">
            Más de 30 recetas listas en menos de 20 minutos, organizadas por
            momento del día, con ingredientes de heladera. Sin pensar. Sin
            complicarte. Sin culpa.
          </p>

          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-4 gap-y-2 text-sm text-brand-purpleDark font-medium mt-2" data-id="element-93">
            <div className="flex items-center gap-1" data-id="element-94">
              <Check className="w-4 h-4 text-brand-purple" data-id="element-95" />
              <span data-id="element-96">Acceso inmediato</span>
            </div>
            <div className="hidden sm:block text-brand-purple/30" data-id="element-97">·</div>
            <div className="flex items-center gap-1" data-id="element-98">
              <Check className="w-4 h-4 text-brand-purple" data-id="element-99" />
              <span data-id="element-100">Funciona con cualquier marca</span>
            </div>
            <div className="hidden sm:block text-brand-purple/30" data-id="element-101">·</div>
            <div className="flex items-center gap-1" data-id="element-102">
              <Check className="w-4 h-4 text-brand-purple" data-id="element-103" />
              <span data-id="element-104">Garantía de 5 días</span>
            </div>
          </div>

          <div className="mt-6 flex flex-col items-center md:items-start gap-3" data-id="element-105">
            <CtaButton text="→ Quiero mis recetas ahora" size="xl" className="w-full" data-id="element-106" />
            <p className="text-sm text-brand-mediumGray" data-id="element-107">
              Descarga instantánea en PDF — abrilo desde cualquier dispositivo
            </p>
          </div>
        </div>

        {/* Image / Mockup */}
        <div className="relative mx-auto w-full max-w-md md:max-w-full lg:pl-10 z-10 mt-8 md:mt-0" data-id="element-108">
          <img src="https://cdn.magicpatterns.com/uploads/gvNRSBs7CPvvhShmiBmZAh/AC358B5D-8A9E-4683-8767-26B49CF693EA.png" alt="Libro Recetas en Air Fryer" className="w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-109" />
        </div>
      </div>
    </section>;
}